(() => {
  if (window.studioPagesReady) return;
  window.studioPagesReady = true;
  function prepare(scope) {
    scope.querySelectorAll('.st-address-form').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const country = form.querySelector('[data-st-country]');
      const province = form.querySelector('[data-st-province]');
      const wrapper = form.querySelector('[data-st-province-wrap]');
      if (!country || !province || !wrapper) return;
      if (country.dataset.default) {
        const match = [...country.options].find(option => option.value === country.dataset.default || option.text === country.dataset.default);
        if (match) country.value = match.value;
      }
      const update = () => {
        let regions = [];
        try { regions = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch {}
        province.replaceChildren(...regions.map(([value, label]) => new Option(label, value)));
        if ([...province.options].some(option => option.value === province.dataset.default)) province.value = province.dataset.default;
        wrapper.hidden = regions.length === 0;
        province.disabled = regions.length === 0;
      };
      country.addEventListener('change', update);
      update();
    });
    scope.querySelectorAll('details:has(.st-form-errors)').forEach(details => details.open = true);
    if (location.hash === '#recover' || scope.querySelector('#recover [role="status"]')) {
      const recovery = document.getElementById('recover');
      if (recovery) recovery.open = true;
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-st-delete-address]');
    if (form && !window.confirm(form.dataset.confirm)) event.preventDefault();
  });
  document.addEventListener('click', async event => {
    const print = event.target.closest('[data-st-print]');
    if (print) window.print();
    const button = event.target.closest('[data-st-share][data-url]');
    if (!button) return;
    const url = button.dataset.url || location.href;
    try {
      if (navigator.share) await navigator.share({title:button.dataset.title, url});
      else if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
        button.textContent = button.dataset.copied;
      } else {
        let input = button.parentElement.querySelector('.st-copy-fallback');
        if (!input) {
          input = document.createElement('input');
          input.type = 'url'; input.readOnly = true; input.className = 'st-copy-fallback';
          input.setAttribute('aria-label', button.textContent.trim());
          button.insertAdjacentElement('afterend', input);
        }
        input.value = url; input.focus(); input.select();
      }
    } catch (error) {
      if (error.name !== 'AbortError') button.dispatchEvent(new CustomEvent('studio:share-error', {bubbles:true}));
    }
  });
  document.addEventListener('shopify:section:load', event => prepare(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare(document)); else prepare(document);
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let queued = false;
    const paint = () => {
      queued = false;
      document.querySelectorAll('[data-st-parallax]').forEach(media => {
        const image = media.querySelector('img');
        if (!image) return;
        const box = media.getBoundingClientRect();
        if (box.bottom < 0 || box.top > innerHeight) return;
        const progress = Math.max(-1, Math.min(1, (box.top + box.height / 2 - innerHeight / 2) / innerHeight));
        const offset = progress * 24;
        image.style.transform = media.dataset.stParallax === 'horizontal' ? `scale(1.1) translateX(${offset}px)` : media.dataset.stParallax === 'zoom' ? `scale(${1.04 + Math.abs(progress) * .08})` : `scale(1.1) translateY(${offset}px)`;
      });
    };
    window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(paint); } }, {passive:true});
    paint();
  }
})();
